export class FieldNotDefinedError extends Error {
    constructor(fieldName: string) {
        super(`${fieldName} has not been defined`);
    }
}
